// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const { keyedReviver } = require('client-v2/common/state/revivers')
// Model imports
const { USER_FOLLOWING_CHANGE_PENDING } = require('./actions')

class UserModelRecord extends Immutable.Record({
  bio: String(),
  'display_name': String(),
  'follower_count': Number(),
  'header_image_url': String(),
  'header_image_urls': null,
  id: Number(),
  isFollowing: Boolean(),
  isVerifiedCurator: Boolean(),
  mixesBio: String(),
  'photo_url': String(),
  type: String(modelTypes.USER),
  username: String()
}) {
  // No methods
}

UserModelRecord.reviver = keyedReviver(UserModelRecord, {
  'header_image_urls': ImageUrlSizes.reviver
})

UserModelRecord.propTypes = {
  bio: PropTypes.string,
  'display_name': PropTypes.string.isRequired,
  'follower_count': PropTypes.number,
  'header_image_url': PropTypes.string,
  'header_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
  id: PropTypes.number.isRequired,
  isFollowing: PropTypes.oneOf([true, false, USER_FOLLOWING_CHANGE_PENDING]),
  isVerifiedCurator: PropTypes.bool,
  mixesBio: PropTypes.string,
  'photo_url': PropTypes.string,
  username: PropTypes.string.isRequired
}

module.exports = UserModelRecord
